export const CREATE_ACCOUNT = '[Auth] Create Account';
export const CREATE_ACCOUNT_SUCCESS = '[Auth] Create Account Success';
export const CREATE_ACCOUNT_ERROR = '[Auth] Create Account Error';

export const RESEND_CODE = '[Auth] Resend Code';
export const RESEND_CODE_SUCCESS = '[Auth] Resend Code Success';
export const RESEND_CODE_ERROR = '[Auth] Resend Code Error';

export const VERIFY_ACCOUNT = '[Auth] Verify Account';
export const VERIFY_ACCOUNT_SUCCESS = '[Auth] Verify Account Success';
export const VERIFY_ACCOUNT_ERROR = '[Auth] Verify Account Error';

export const LOGIN_USER = '[Auth] Login User';
export const LOGIN_USER_SUCCESS = '[Auth] Login User Success';
export const LOGIN_USER_ERROR = '[Auth] Login User Error';
export const LOGIN_USER_ERROR_GOOGLE = '[Auth] Google Login User Error';
export const LOGIN_USER_SUCCESS_RECENTLY = '[Auth] Login User Success Recently';

export const LOGOUT_USER = '[Auth] Logout User';
export const LOGOUT_USER_SUCCESS = '[Auth] Logout User Success';
export const LOGOUT_USER_ERROR = '[Auth] Logout User Error';

export const USER_CONFIGURED = '[Auth] User Configured';

export const FORGOT_PASSWORD_START = '[Auth] Start Forgot password';
export const FORGOT_PASSWORD_START_SUCCESS =
  '[Auth] Start Forgot password Success';
export const FORGOT_PASSWORD_START_ERROR = '[Auth] Start Forgot password Error';

export const FORGOT_PASSWORD = '[Auth] Forgot password';
export const FORGOT_PASSWORD_SUCCESS = '[Auth] Forgot password Success';
export const FORGOT_PASSWORD_ERROR = '[Auth] Forgot password Error';

export const CHANGE_PASSWORD = '[Auth] Change password';
export const CHANGE_PASSWORD_SUCCESS = '[Auth] Change password Success';
export const CHANGE_PASSWORD_ERROR = '[Auth] Change password Error';

export const CHANGE_LOGIN = '[Auth] Change login';
export const CHANGE_LOGIN_SUCCESS = '[Auth] Change login Success';
export const CHANGE_LOGIN_ERROR = '[Auth] Change login Error';

export const UPDATE_TOKEN_DATA = '[Auth] Update token data';
export const UPDATE_TOKEN_DATA_SUCCESS = '[Auth] Update token data Success';
